import React, { useState } from "react";
import { InfoCircle } from "../../../public/assets";

interface InfoCircleProps {
  message?: string;
  className?: string;
}

const InfoCircles: React.FC<InfoCircleProps> = ({ message, className }) => {
  const [showMessage, setShowMessage] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowMessage(true)}
      onMouseLeave={() => setShowMessage(false)}
      style={{ position: "relative", display: "flex", width: "50%" }}
      className={className}
    >
      <img
        src="/assets/svg/info-circle.svg"
        alt=""
        style={{ paddingLeft: "10px", position: "relative", zIndex: 1 }}
      />
      {showMessage && (
        <div
          style={{
            position: "absolute",
            bottom: "12px",
            left: "60%",
            transform: "translateX(-50%)",
            width: "100%",
            background: "white",
            boxShadow: "-3px 5px 15px 0px #B0B0B040",
            padding: "10px 10px 10px 15px",
            zIndex: 999,
            color: "#08004C",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            borderRadius: "12px",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default InfoCircles;
